import { DataCache, ForeignKeyRelationship, SharedKeyRelationship, QueryResultRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';

import { DraftCharge, DraftChargeOptions } from 'data/models/DraftCharge';
import { DraftChargeCollection } from 'data/models/DraftChargeCollection';
import { OriginalPilotOrder } from 'data/models/OriginalPilotOrder';
import { PilotJobOrderDetails } from 'data/models/PilotJobOrderDetails';
import { PilotJobOrderDetailsBilling } from 'data/models/PilotJobOrderDetailsBilling';

export class PilotJobOrderDetailsCache extends DataCache {
    PilotJobOrderDetailses = PCCollection(PilotJobOrderDetails);
    PilotJobOrderDetailsBillings = PCCollection(PilotJobOrderDetailsBilling);
    DraftChargeCollections = PCCollection(DraftChargeCollection);
    DraftCharges = PCCollection<DraftCharge, DraftChargeOptions>(DraftCharge);
    OriginalPilotOrders = PCCollection(OriginalPilotOrder);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship(this.PilotJobOrderDetailses, data.PilotJobOrders, d => d.PilotJobOrder, null);
        new SharedKeyRelationship(this.PilotJobOrderDetailsBillings, data.PilotJobOrders, b => b.PilotJobOrder, null);
        new SharedKeyRelationship(this.DraftChargeCollections, this.PilotJobOrderDetailsBillings, null, b => b.DraftCharges);
        new ForeignKeyRelationship(this.DraftChargeCollections, this.DraftCharges, col => col.Charges, c => c.ChargeCollection, c => c.ChargeCollectionId());
        new ForeignKeyRelationship(data.StandardItems, this.DraftCharges, null, c => c.StandardItem, c => c.StandardItemId());
        new ForeignKeyRelationship(data.Rates,         this.DraftCharges, null, c => c.StandardRate, c => c.StandardRateId());
        new QueryResultRelationship(this.OriginalPilotOrders, data.PortCallPITs, r => r.OriginalOrder);
    }
}



// WEBPACK FOOTER //
// ./apps/pilots/pilotjoborderdetails/cache.ts